import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';

function useTranslationCatalog(keyPrefix?: string): TFunction {
  const { t } = useTranslation(Domain.CATALOG, { keyPrefix });

  return t;
}

export default useTranslationCatalog;
